// src/systems/cameraSystem.ts — Cámara suave que sigue al jugador (Fase 2)
import { GAME_CONFIG } from '../data/gameConfig.js';

export class Camera {
  x = 0; y = 0; // top-left en píxeles mundo
  private targetX=0; private targetY=0;
  constructor(public vw: number, public vh: number) {}

  resize(vw:number, vh:number): void { this.vw=vw; this.vh=vh; }

  // Seguir jugador (px) con clamping a bordes del mapa
  follow(playerPx: {x:number,y:number}, mapPx: {w:number,h:number}, lerp=0.12): void {
    this.targetX = playerPx.x + GAME_CONFIG.tileSize/2 - this.vw/2;
    this.targetY = playerPx.y + GAME_CONFIG.tileSize/2 - this.vh/2;
    const maxX = Math.max(0, mapPx.w - this.vw);
    const maxY = Math.max(0, mapPx.h - this.vh);
    this.targetX = Math.max(0, Math.min(maxX, this.targetX));
    this.targetY = Math.max(0, Math.min(maxY, this.targetY));
    // lerp
    this.x += (this.targetX - this.x) * lerp;
    this.y += (this.targetY - this.y) * lerp;
    // snap si muy cerca
    if (Math.abs(this.targetX-this.x) < 0.5) this.x=this.targetX;
    if (Math.abs(this.targetY-this.y) < 0.5) this.y=this.targetY;
  }

  snap(playerPx:{x:number,y:number}, mapPx:{w:number,h:number}): void {
    this.follow(playerPx, mapPx, 1);
  }
}
